import type { AppContext } from './_type';

import { createContext, useContext } from 'react';

export const Context = createContext({} as AppContext);

export const useAppContext = () => useContext(Context);
